module.exports = __webpack_public_path__ + "static/media/pict-11.eec91803.svg";